import {Component, OnInit, Input, NgModule, NO_ERRORS_SCHEMA, AfterViewInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {Depreciation} from '../depreciation';
import {DepreciationService} from '../depreciation.service';
import {ActivatedRoute, Router} from '@angular/router';
import {SharedService} from '../../../../services/SharedService.service';
import {ConfirmationService, Message, SelectItem} from 'primeng/api';
import {MessageService} from 'primeng/components/common/messageservice';
import {NgbActiveModal, NgbModal, NgbModalOptions, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {AppLogComponent} from '../../../../components/app-log/app-log.component'
import {appConfig} from "../../../../app.config";
import {TranslateLoader, TranslateModule, TranslateService} from "@ngx-translate/core";
import {BrowserModule} from "@angular/platform-browser";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {CommonModule} from "@angular/common";
import {ConfirmDialogModule, DropdownModule, MessagesModule} from "primeng/primeng";
import {Http} from "@angular/http";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import {UserPictureComponent} from "../../../../components/user-picture";
import {RecordDataComponent} from "../../../../components/record-data";
import {AppArcComponent} from "../../../../components/app-arc";
import {ItemsGroupsShowComponent} from "../../../setting/itemsGroups/itemsGroups-show/itemsGroups-show.component";
import {CurrenciesShowComponent} from "../../../setting/currencies/currencies-show/currencies-show.component";
import {EmployeesShowComponent} from "../../../setting/employees/employees-show/employees-show.component";
import {ItemService} from "../../../setting/items/items.service";
import {SupplierService} from "../../../setting/suppliers/supplier.service";
import {ItemsGroupService} from "../../../setting/itemsGroups/itemsGroups.service";
import {TaxService} from "../../../setting/taxes/tax.service";
import {formatDate} from "ngx-bootstrap/chronos";
import {forEach} from "@angular/router/src/utils/collection";
import {BranchService} from "../../../setting/branches/branch.service";
import {MyInputsModule} from "../../../../my-inputs/my-inputs.module";
import {ItemsShowComponent} from "../../../setting/items/items-show/items-show.component";
import {BranchesShowComponent} from '../../../setting/branches/branches-show/branches-show.component';

@NgModule({
    imports: [CommonModule, FormsModule, DropdownModule, MessagesModule,MyInputsModule,
        ReactiveFormsModule, ConfirmDialogModule, TranslateModule.forChild()
    ],
    declarations: [
        DepreciationShowComponent
    ],
    entryComponents: [
        DepreciationShowComponent
    ],
    exports: [],
    providers: [SharedService, DepreciationService, MessageService, ConfirmationService, SupplierService],
    schemas: [NO_ERRORS_SCHEMA]
})

@Component({
    selector: 'app-depreciation-show',
    templateUrl: './depreciation-show.component.html',
    styleUrls: ['./depreciation-show.component.scss'],
    providers: [DepreciationService, ConfirmationService, MessageService, SupplierService]
})

export class DepreciationShowComponent implements OnInit, AfterViewInit {
    id: string;
    picture: string;
    depreciation = new Depreciation();
    status: string;
    cnamelock = false;
    depreciation_groups_id: string;
    statusVal = [{'val': 1, 'title': 'Yes'}, {'val': 2, 'title': 'No'}];
    form: FormGroup;
    public tax: number;
    private sub: any;
    branches: any[] = [];
    cities: any[] = [];
    bank: any[] = [];
    suppliers: any[] = [];
    allinvdetails: any[] = [];
    alldepreciationd: any[] = [];
    today = formatDate(new Date(), "YYYY-MM-DD");
    public item_name: string;
    Selecteditem: any;
    Selecteditemcost: any = 0.0;
    Selecteditemquty: any = 0.0;
    Selecteditemtotal_b_tax: any;
    Selecteditemtotal_a_tax: any;
    Selecteditemtax: any;
    Selecteditemdetails: any;
    Selected_payment: any[] = [];
    itemCount: any[] = [];
    deletedrow: any[] = [];
    selectedrow: any[] = [];

    Selected_items: any[] = [];
    items: SelectItem[] = [];
    Selected_items_db: string[] = [];
    selectedItem: any[] = [];
    allitems: any = [];
    items_enhance: any = [];
    msgs: Message[] = [];
    public imgUrl = appConfig.publicUrl;
    emailPattern = "^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$";
    webPattern = "^www+\.[a-z0-9.-]+\.[a-z]{2,4}$";
    emailErr: boolean = false;
    siteErr: boolean = false;
    public focusname = true;
    itemCountPayment: any[] = [];
    payment_list: any[] = [];

    allbranches: any[] = [];
    branches_enhance: any[] = [];

    @Input() refShow;
    // picture:string;x
    applog: AppLogComponent;
    parent_name: any;
    @Input() scrId;
    modalRef: NgbModalRef;
    parent: any;
  @Input() delId;
  @Input() oldData;
  @Input() newData;
  @Input() newDatap;
  @Input() modelName;


    defVal = [{'val': 1, 'title': 'Yes'}, {'val': 0, 'title': 'No'}];
    DescVal = [{'val': 1, 'title': 'Percentage'}, {'val': 2, 'title': 'Cost'}];

    private item: any;
    mainitem: any = {value: "", inx: -1};

    // deletedrow: any[] = [];
    deletedrowPayment: any[] = [];


    invoice_arr: any[] = [];
    invoice_list_arr: any[] = [];
  inv_old_list_arr: any[] = [];
  restoreInv: any;
  invoice_payment_arr: any[] = [];
    public allpaid: any = 0.0;
    public allremain: any = 0.0;
    allquty: any = 0;
    allcost_b_tax: any = 0;
    allcost_a_tax: any = 0;
    alltaxes: any = 0;
    allAdisscount: any = 0;
    allAddtaxes: any = 0;
    allcostsforone: any = 0;
    alldiscountvalue: any = 0;
    private _editButton: any;
    private _deleteButton: any;
    private _newButton: any;
    private _printButton: any;
    private _searchButton: any;

    constructor(private route: ActivatedRoute,
                private router: Router,
                private sharedservice: SharedService,
                private depreciationService: DepreciationService,
                private modalService: NgbModal,
                private itemservice: ItemService,
                private branchService: BranchService,
                private itemGroup: ItemsGroupService,
                private formBuilder: FormBuilder,
                private supplierService: SupplierService,
                public activeModal: NgbActiveModal,
                public translate: TranslateService,
                private confirmationService: ConfirmationService,
                private messageService: MessageService) {
        const userdata = JSON.parse(localStorage.getItem('currentUser'));
        this.msgs = [];

        if (userdata && userdata.lang) {
            this.translate.use(userdata.lang);
        }
        this.sharedservice.setTitle(this.route.snapshot.data.title);
      this.sharedservice.setItemShow(DepreciationShowComponent);
        this.sharedservice.setButtons([
            {label: 'Delete', icon: 'fa-trash', btnClass: 'btn-danger', btnId: 'deleteButton'},
            {label: 'Edit', icon: 'fa-edit', btnClass: 'btn-warning', btnId: 'editButton'},
            // {label: 'Print', icon: 'fa-print', btnClass: 'btn-skype', btnId: 'printButton'},
            {label: 'Add', icon: 'fa-plus', btnClass: 'btn-info', btnId: 'newButton'},
            {label: 'Query', icon: 'fa-search', btnClass: 'btn-primary', btnId: 'searchButton'},

        ]);
        this.sharedservice.setModelName('depreciation');

    }

    showParent() {
        if (this.parent) {
            const options: NgbModalOptions = {

                beforeDismiss: () => {
                    console.log("before dismiss");
                    return true;
                }
            };
            this.modalRef = this.modalService.open(BranchesShowComponent, options);
            this.modalRef.componentInstance.scrId = this.parent;

            this.modalRef.result.then(() => {
                this.activeModal.dismiss('done');
            }, () => {
                console.log('Backdrop click')
            });
        }
    }

  showItem(id){
    console.log(id);
    const options: NgbModalOptions = {

      beforeDismiss: () => {
        console.log("before dismiss");
        //
        return true;
      }
    };
    this.modalRef = this.modalService.open(ItemsShowComponent, options);
    this.modalRef.componentInstance.scrId = id;

    this.modalRef.result.then(() => {
      this.activeModal.dismiss('done');
    }, () => {
      console.log('Backdrop click')
    });
  }


    recordData() {
        const options: NgbModalOptions = {

            beforeDismiss: () => {
                // this.changePicUrl();
                return true;
            }
        };
        const modalRef = this.modalService.open(RecordDataComponent, options);
        modalRef.componentInstance.refRec = this.depreciation;
        modalRef.componentInstance.rowId = '';

    }

    ngAfterViewInit() {
        if(!this.scrId && !this.oldData) {
            this._editButton = document.getElementById('editButton');
            this._deleteButton = document.getElementById('deleteButton');
            this._newButton = document.getElementById('newButton');
            this._printButton = document.getElementById('printButton');
            this._searchButton = document.getElementById('searchButton');


            if (this._editButton) {
                this._editButton.onclick = ((e: any) => {
                    e.preventDefault();
                    this.router.navigate(['/depreciation/edit', this.id]);
                });
            }
            if (this._deleteButton) {

                this._deleteButton.onclick = ((e: any) => {
                    e.preventDefault();
                    this.deleteDepreciation(this.depreciation);
                });
            }
            if (this._newButton) {

                this._newButton.onclick = ((e: any) => {
                    e.preventDefault();
                    this.router.navigate(['/depreciation']);
                });

            }
            if (this._searchButton) {
                this._searchButton.onclick = ((e: any) => {
                    e.preventDefault();
                    this.router.navigate(['/depreciation/search']);
                });

            }
        }
    }

    ngOnInit() {
        this.msgs = [];

      this.branchService.getUserBranches().subscribe(
        allbranches => {
          this.branches = allbranches.brancheslist;

        });


      this.itemservice.getAllItems().subscribe(
        items => {
          this.allinvdetails = items.itemslist;
          this.items = items.itemslist;
        });

      this.sub = this.route.params.subscribe(params => {
        this.id = params['id'];


      });

      this.form = new FormGroup({
        id: new FormControl({value: '', disabled: true}),

        date: new FormControl({value: '', disabled: true}),
        time: new FormControl({value: '', disabled: true}),
        depreciation_reason_details: new FormControl({value: '', disabled: true}),
        // storage_branch: new FormControl('', Validators.required),
        branch_id: new FormControl({value: '', disabled: true}),

      });

      if (this.id) {
        this.oldData = false;
        this.newData = false;
        this.delId = false;
        this.newDatap = true;
        this.depreciationService.getById(this.id).subscribe(
          depreciation => {
            this.id = depreciation.depreciation.id;
            this.depreciation = depreciation.depreciation;
            this.invoice_list_arr = depreciation.itemsdetails;
            this.parent = depreciation.depreciation.branch_id;
            this.form.patchValue({
              id: depreciation.depreciation.id,
              date: depreciation.depreciation.date,
              time: depreciation.depreciation.time,
              depreciation_reason_details: depreciation.depreciation.depreciation_reason_details,
              branch_id: depreciation.depreciation.branch_id,
            });
            this.Selected_items = [];
            for(let i=0; i< this.invoice_list_arr.length; i++) {

              let iserte = {
                item_id: this.invoice_list_arr[i].item_id,
                quantity:this.invoice_list_arr[i].quantity
              };

              this.selectedItem.push(this.invoice_list_arr[i].item_id);

              this.Selected_items[i] = iserte;
            }

            this.itemCount = Array(this.Selected_items.length ).fill(2);

            // window.alert(this.allremain);
          }, error => {
            console.log(error);
          }
        );

      }
        if (this.scrId) {
            this.oldData = false;
            this.newData = false;
            this.delId = false;

          this.depreciationService.getById(this.scrId).subscribe(
            depreciation => {
              console.log(depreciation);
              this.invoice_arr = depreciation.depreciation;
              this.invoice_list_arr = depreciation.itemsdetails;
              this.selectedItem = depreciation.selecteditems;
              this.id = depreciation.depreciation.id;
              this.depreciation = depreciation.depreciation;
              this.parent = depreciation.depreciation.branch_id;
              this.form.patchValue({
                id: depreciation.depreciation.id,
                date: depreciation.depreciation.date,
                time: depreciation.depreciation.time,
                depreciation_reason_details: depreciation.depreciation.depreciation_reason_details,
                branch_id: depreciation.depreciation.branch_id,

              });

              for(let i=0; i<this.invoice_list_arr.length; i++){
                let iserte = {
                  item_id: this.invoice_list_arr[i].item_id,
                  quantity:this.invoice_list_arr[i].quantity
                };
                this.Selected_items[i] = iserte;
              }
              this.itemCount = Array(this.Selected_items.length ).fill(2);



            }, error => {
              console.log(error);
            }
          );

        }
        if (this.delId) {
            this.oldData = false;
            this.newData = false;
          this.newDatap = !this.newDatap ;

            this.depreciationService.getTrashedById(this.delId).subscribe(
                depreciation => {
                    this.id = depreciation.invoice.id;
                  this.depreciation = depreciation.invoice;
                  this.invoice_list_arr = depreciation.itemsdetails;
                  this.Selected_items = depreciation.selecteditems;
                    this.depreciation = depreciation.invoice;
                  this.parent = depreciation.invoice.branch_id;
                    this.form.patchValue({
                        id: depreciation.invoice.id,
                      date: depreciation.invoice.date,
                      time: depreciation.invoice.time,
                      depreciation_reason_details: depreciation.invoice.depreciation_reason_details,
                      branch_id: depreciation.invoice.branch_id,

                    });
                  this.Selected_items = [];
                  for(let i=0; i< this.invoice_list_arr.length; i++) {

                    let iserte = {
                      item_id: this.invoice_list_arr[i].item_id,
                      quantity:this.invoice_list_arr[i].quantity
                    };

                    this.selectedItem.push(this.invoice_list_arr[i].item_id);

                    this.Selected_items[i] = iserte;
                  }

                  this.itemCount = Array(this.Selected_items.length ).fill(2);
                   // this.changeallremain();
                }, error => {
                    console.log(error);
                }
            );
        }

        if (this.oldData && this.newData) {
          console.log("show",this.oldData,this.newData);
            this.depreciation = this.newData.invoice;
          this.parent = this.newData.invoice.branch_id;
          this.invoice_list_arr = this.newData.itemsdetails;
          this.restoreInv = this.oldData.invoice;
          this.restoreInv.inv_details = JSON.stringify(this.oldData.itemsdetails);
          this.inv_old_list_arr = this.oldData.itemsdetails;
            this.form.patchValue({
                id: this.newData.invoice.id,
              date: this.newData.invoice.date,
              time: this.newData.invoice.time,
              depreciation_reason_details: this.newData.invoice.depreciation_reason_details,
              branch_id: this.newData.invoice.branch_id,
            });

          this.Selected_items = [];
          for(let i=0; i< this.invoice_list_arr.length; i++) {

            let iserte = {
              item_id: this.invoice_list_arr[i].item_id,
              quantity:this.invoice_list_arr[i].quantity
            };

            this.selectedItem.push(this.invoice_list_arr[i].item_id);

            this.Selected_items[i] = iserte;
          }

          this.itemCount = Array(this.Selected_items.length ).fill(2);

        }
    }

    permissionAllow(button: string): boolean {
        let userRoles: any[] = [];
        const userdata = JSON.parse(localStorage.getItem('currentUser'));
        if (userdata) {
            userRoles = userdata.roles.description;
        }
        let role: string = '';
        switch (button) {
            case 'newButton': {
                role = 'create';
                break;
            }
            /*  case 'recordDataButton': {
                  role = 'recordData';
                  break;
              }*/
            case 'saveButton': {
                role = 'update';
                break;
            }
            case 'deleteButton': {
                role = 'delete';
                break;
            }
            case 'searchButton': {
                role = 'search';
                break;
            }
            case 'excelButton': {
                role = 'excel';
                break;
            }
            case 'printButton': {
                role = 'print';
                break;
            }
            case 'historyButton': {
                role = 'history';
                break;
            }
            case 'restoreButton': {
                role = 'restore';
                break;
            }
            case 'attachmentsButton': {
                role = 'attachments';
                break;
            }
            case 'rowinfo': {
                role = 'rowinfo';
                break;
            }

            default: {
                role = '';
                break;
            }
        }
        if (userRoles.indexOf('setting.depreciation.' + role) >= 0) {
            return true;
        }
        return false;
    }

    deleteDepreciation(depreciation: Depreciation) {
        this.confirmationService.confirm({
            header: this.translate.instant('Confirm Delete'),
            message: this.translate.instant('Are you sure of delete ?'),
            icon: 'fa fa-trash',
            accept: () => {
                if (depreciation) {
                    this.depreciationService.delete(depreciation.id).subscribe(
                        res => {
                            this.msgs = [];
                            this.msgs.push({
                                severity: 'success',
                                summary: '',
                                detail: this.translate.instant('Delete completed')
                            });
                            setTimeout(() => {
                                this.router.navigate(['/depreciation']);
                            }, 1000);
                            //localStorage.setItem('showMessages', JSON.stringify(this.msgs));

                        }
                    );
                }
            }
        });
    }

    changeallremain() {

        this.allremain = 0.0;
        this.allquty = 0.0;
        this.allcostsforone = 0.0;
        this.allcost_b_tax = 0.0;
        this.allcost_a_tax = 0.0;
        this.alltaxes = 0.0;

        for (let i = 0; i < this.Selected_items.length; i++) {
            // window.alert(this.allquty);

            this.allquty += parseFloat(this.Selected_items[i].qty);
            this.allcostsforone += parseFloat(this.Selected_items[i].cost);
            this.allcost_b_tax += parseFloat(this.Selected_items[i].totalBtax);
            this.allcost_a_tax += parseFloat(this.Selected_items[i].totalAtax);
            this.allAdisscount += parseFloat(this.Selected_items[i].costADiscount);
            this.allAddtaxes += parseFloat(this.Selected_items[i].addTax);

            this.alltaxes += parseFloat(this.Selected_items[i].taxvalue);
        }

        let discv = this.form.controls['disc_value'].value;
        let disct = this.form.controls['disc_type'].value;
        console.log(discv);
        if (disct == 1) {
            this.alldiscountvalue = (parseFloat(this.allcost_a_tax) * parseFloat(discv) / 100).toFixed(2);
        } else {
            this.alldiscountvalue = parseFloat(discv).toFixed(2);
        }

        this.allremain = (parseFloat(this.allcost_a_tax) - parseFloat(this.alldiscountvalue) - parseFloat(this.allpaid)).toFixed(2);
    }

    recoverEdit(depreciation: Depreciation) {
        this.confirmationService.confirm({
            header: this.translate.instant('Confirm Undo Edit'),
            message: this.translate.instant('Are you sure of undo ?. All data will be recover as seen in screen and any other editing will be dismiss'),
            icon: 'fa fa-undo',
            accept: () => {
                if (depreciation) {
                    this.depreciationService.update(depreciation).subscribe(
                        res => {
                            this.msgs = [];
                            this.msgs.push({
                                severity: 'success',
                                summary: '',
                                detail: this.translate.instant('Data returned')
                            });
                            this.activeModal.close('done');
                            this.router.navigate(['/depreciation/show', depreciation.id]);
                        }
                    );
                }
            }
        });
    }

    undotrashed() {
        this.confirmationService.confirm({
            header: this.translate.instant('Confirm Undo Delete'),
            message: this.translate.instant('Are you sure about recover deleted item?'),
            icon: 'fa fa-undo',
            accept: () => {
                if (this.delId) {
                    this.depreciationService.restoreTrashedById(this.delId).subscribe(
                        res => {
                            this.msgs = [];
                            this.msgs.push({
                                severity: 'success',
                                summary: '',
                                detail: this.translate.instant('Deleted depreciation recovered')
                            });
                            this.activeModal.dismiss('close click');
                            this.router.navigate(['/depreciation/list']);
                        }
                    );
                }
            }
        });
    }

    showattachement(row_id: string) {
        console.log(row_id)
        if (row_id) {
            const options: NgbModalOptions = {

                beforeDismiss: () => {
                    // this.changePicUrl();
                    return true;
                }
            };
            const modalRef = this.modalService.open(AppArcComponent, options);
            modalRef.componentInstance.rowId = row_id;
            modalRef.componentInstance.screenName = this.modelName;
        }
    }

    showHistory(row_id: string) {
        if (row_id) {
            const modalRef = this.modalService.open(AppLogComponent);
            modalRef.componentInstance.refShow = DepreciationShowComponent;

            modalRef.componentInstance.rowId = row_id;
        }
    }

    changallpaid() {
        this.allpaid = 0.0;
        for (let i = 0; i < this.Selected_payment.length; i++) {
            console.log(this.Selected_payment[i].payment_amount);
            this.allpaid += parseFloat(this.Selected_payment[i].payment_amount);
        }
        let discv = this.form.controls['disc_value'].value;
        let disct = this.form.controls['disc_type'].value;
        console.log(discv);
        if (disct == 1) {
            this.alldiscountvalue = (parseFloat(this.allcost_a_tax) * parseFloat(discv) / 100).toFixed(2);
        } else {
            this.alldiscountvalue = parseFloat(discv).toFixed(2);
        }

        this.allremain = (parseFloat(this.allcost_a_tax) - parseFloat(this.alldiscountvalue) - parseFloat(this.allpaid)).toFixed(2);

    }

    changealldiscount() {
        let discv = this.form.controls['disc_value'].value;
        let disct = this.form.controls['disc_type'].value;

        console.log(disct);
        console.log(discv);
        if (disct == 1) {
            this.alldiscountvalue = (parseFloat(this.allcost_a_tax) * parseFloat(discv) / 100).toFixed(2);
        } else {
            this.alldiscountvalue = parseFloat(discv).toFixed(2);
        }
        console.log(this.alldiscountvalue);
        //this.changallpaid();
        this.changeallremain();


    }


}



// WEBPACK FOOTER //
// ./src/app/views/pro/depreciation/depreciation-show/depreciation-show.component.ts